import { useId } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { cn } from "@utils";
import Banner from "./Banner";

// A Banner whose header toggles a collapsible body. The coloured shell + icon + summary
// row all come from Banner (so it matches every other notice bar); this adds the Show/Hide
// toggle and the grid-based expand/collapse of `children`. The header button announces its
// state via aria-expanded/aria-controls, pointing at the content region's id.
export default function CollapsibleBar({
  icon,
  borderColor,
  bgColor,
  textColor,
  open,
  onToggle,
  summary,
  count,
  children,
}) {
  const contentId = useId();

  return (
    <Banner
      icon={icon}
      message={summary}
      textClassName={textColor}
      borderColor={borderColor}
      bgColor={bgColor}
      onHeaderClick={onToggle}
      headerButtonProps={{ "aria-expanded": open, "aria-controls": contentId }}
      className={open ? "min-h-0 flex-1" : "shrink-0"}
      trailing={
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          aria-controls={contentId}
          className="flex shrink-0 items-center gap-1 text-xs font-medium text-primary"
        >
          {open ? "Hide" : "Show"} ({count})
          <ChevronDownIcon
            className={cn("size-4 transition-transform", open && "rotate-180")}
          />
        </button>
      }
    >
      <div
        id={contentId}
        className={cn("grid overflow-hidden", open ? "min-h-0 flex-1" : "flex-none")}
        style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
      >
        <div
          className={cn(
            "min-h-0 overflow-x-hidden",
            open ? "overflow-y-auto" : "overflow-y-hidden",
          )}
        >
          {children}
        </div>
      </div>
    </Banner>
  );
}
